import commonEn from './locales/en/common.json';
import layoutEn from './locales/en/layout.json';
import commonAr from './locales/ar/common.json';
import layoutAr from './locales/ar/layout.json';

/** Bundled up front so first paint has shell + layout for each language. */
export const preloadedI18nResources = {
  en: {
    common: commonEn,
    layout: layoutEn,
  },
  ar: {
    common: commonAr,
    layout: layoutAr,
  },
};

/** Lazy-loaded namespaces per locale (file names differ: en uses exercises-library.json). */
export const namespaceToPathByLng = {
  en: {
    patients: () => import('./locales/en/patients.json'),
    staff: () => import('./locales/en/staff.json'),
    settings: () => import('./locales/en/settings.json'),
    auth: () => import('./locales/en/auth.json'),
    help: () => import('./locales/en/help.json'),
    home: () => import('./locales/en/home.json'),
    exercise: () => import('./locales/en/exercises-library.json'),
    physiotherapists: () => import('./locales/en/physiotherapists.json'),
    clinicsAdmins: () => import('./locales/en/clinics-admins.json'),
    appointments: () => import('./locales/en/appointments.json'),
    terms: () => import('./locales/en/terms.json'),
  },
  ar: {
    patients: () => import('./locales/ar/patients.json'),
    staff: () => import('./locales/ar/staff.json'),
    settings: () => import('./locales/ar/settings.json'),
    auth: () => import('./locales/ar/auth.json'),
    help: () => import('./locales/ar/help.json'),
    home: () => import('./locales/ar/home.json'),
    exercise: () => import('./locales/ar/exercise-library.json'),
    physiotherapists: () => import('./locales/ar/physiotherapists.json'),
    clinicsAdmins: () => import('./locales/ar/clinics-admins.json'),
    appointments: () => import('./locales/ar/appointments.json'),
    terms: () => import('./locales/ar/terms.json'),
  },
};
